import { forwardRef } from 'react'
import { Box, Flex, Input, Text, InputGroup } from '@chakra-ui/react'

export const CustomInputOmni = forwardRef(
  ({ label, placeholder, error, type = 'text', isReadOnly = false, isDisabled = false, textAlign = 'left', ...rest }, ref) => {
    return (
      <Box position="relative" width="full">
        <InputGroup>
          <Input
            pl={label ? '70px' : '4'}
            py="2"
            fontSize="12px"
            borderRadius="md"
            borderColor={error ? 'red.500' : '#313E44'}
            _hover={{ borderColor: error ? 'red.600' : '#2A6990' }}
            _focus={{ borderColor: '#378BBF', boxShadow: '0 0 0 1px #378BBF' }}
            placeholder={placeholder}
            type={type}
            isReadOnly={isReadOnly}
            isDisabled={isDisabled}
            bg={isReadOnly || isDisabled ? 'gray.100' : 'white'}
            textAlign={textAlign}
            ref={ref}
            {...rest}
          />
          {label && (
            <Flex position="absolute" left="0" h="100%" pl="4" align="center" pointerEvents="none" zIndex="2">
              <Text fontSize="12px" fontWeight="medium" color="#313E44" opacity="0.85" mr="2">
                {label}:
              </Text>
            </Flex>
          )}
        </InputGroup>
      </Box>
    )
  }
)

CustomInputOmni.displayName = 'CustomInputOmni'
